import { FiltersWidget } from '../FiltersWidget';
import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';

declare var PlanManager: any;

export class BudgetsFilterWidget extends FilterGroup {

    roomsChildrenCount: any = {};
    roomsWatcher: NodeJS.Timeout | null = null;
    cachedSelectedEntities: any[] = [];
    selectedEntitiesWatcher: NodeJS.Timeout | null = null;

    constructor(container: string) {
        super();
        this.id = 'budgets';
        this.name = 'Budget meubles par pièce';
        this.resource = 'assets';
        this.icon = 'fas fa-lg fa-euro-sign';
        this.container = container;
        this.controller = new FiltersController();
    }

    update(): void {
        this.destroy();
        this.html();
    }

    updateTitles(): void {
        $('.row-title').each((_index, element) => {
            $(element).prop('style', FilterGroup.isBudgetObjectSelected(element.id.split('-').at(-3)));
        });
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }


        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }

        // We only want non kitchen fab objects
        if (!FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            stringFilters += '&q.pipeline.unrealState.eq=ready';
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    };

    html(): void {
        this.isDestroyed = false;
        FilterGroup.getAllObjectPricesAndSupply().then(() => {
            setTimeout(() => {
                $('#inputMDMOnly').prop('checked', FilterGroup.seeOnlyMDMObjects);
                this.cachedSelectedEntities = PlanManager.getInstance().selectedEntities;
                FilterGroup.addEntitySelectionListener(this.updateTitles);

                this.controller.addEventListener('change', () => {
                    FilterGroup.resetRoomBudget();
                    this.update();
                }, 'inputMDMOnly')
            }, 50);
            let html = this.filtersHtml() + `
            <div>
                <span>MDM seulement <input id="inputMDMOnly" type="checkbox"/></span>
                <div class="table-responsive">
                    <table class="table table-striped" style="table-layout: fixed">
                        ${this.getBudgetsTableHeaderHtml()}
                        ${this.getBudgetsBodyHtml()}
                        ${this.getGlobalBudgetsBodyHtml()}
                    </table>
                </div>
            </div>
            `;
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;
        });
    }

    getBudgetsTableHeaderHtml(): string {
        return `
        <thead>
            <tr>
                <th style="text-align: center;width:200px">Pièces/Objets</th>
                <th style="text-align: center;width:100px">Nb exemplaires</th>
                <th style="text-align: center;width:100px">Disponibité</th>
                <th style="text-align: center;width:50px">Total</th>
            </tr>
        </thead>
        `;
    }

    rooms(): any[] {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return;
        }

        var result: any[] = [];
        for (var i = 0; i < instance.world.floors.length; ++i) {
            result = result.concat(instance.world.floors[i].rooms);
        }

        return result;
    };

    getBudgetsBodyHtml(): string {
        let rooms = this.rooms();

        this.roomsWatcher = setInterval(() => {
            let newRooms = this.rooms();
            let changed = newRooms.some((room) => {
                let oldCount = this.roomsChildrenCount[room.name];
                let newCount = room.children.length;
                return oldCount === undefined || oldCount !== newCount;
            });

            if (changed) {
                clearInterval(this.roomsWatcher);
                this.roomsWatcher = null;
                this.update();
            }
        }, 50);

        return rooms.map((room, idx) => {
            this.roomsChildrenCount[room.name] = room.children.length;
            let budget = FilterGroup.getRoomBudget(room);
            let objectsHtml = this.getObjectsHtml(room, idx);
            setTimeout(() => {
                this.controller.addEventListener('click', () => {
                    FilterGroup.toggleRoomCollapsed(room);
                    this.update();
                }, `room-title-${idx}`)
            }, 50);
            return `
            <tbody>
                <tr>
                    <td>
                        <span style="float: left;font-weight: bold;" id="room-title-${idx}">${FilterGroup.getRoomName(room)}</span>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                        <span style="float: left;font-weight: bold;">${budget}€</span>
                    </td>
                </tr>
                ${objectsHtml}
            </tbody>
            `;
        }).join('');
    }

    getObjectsHtml(room: any, idx: number): string {
        let objects = FilterGroup.getRoomDetails(room);
        return objects.map((object, obj_idx) => {
            setTimeout(() => {
                this.controller.addEventListener('click', () => {
                    FilterGroup.clickBudgetObject(object);
                    this.update();
                }, `room-${idx}-objects-${obj_idx}-td`);
            }, 50);

            return `
                <tr ${FilterGroup.isRoomCollapsed(room) ? 'style="display:none"' : ''}>
                    <td id="room-${idx}-objects-${obj_idx}-td">
                        <span style="float: left;">
                            <img src="${FilterGroup.getRoomObjectThumbnailUrl(object)}" height="40px">
                        </span>
                        <span id="room-${idx}-objects-${object.objectId}-${obj_idx}-title" class="row-title" style="${FilterGroup.isBudgetObjectSelected(object.objectId)}">${object.name}</span>
                    </td>
                    <td style="text-align: center;">
                        <span>${object.quantity}</span>
                    </td>
                    <td style="text-align: center;">
                        <span>${object.availability}</span>
                    </td>
                    <td>
                        <span style="float: left;">${object.total.toFixed(2)}€</span>
                    </td>
                </tr>
                `;
        }).join('');
    }

    getGlobalBudgetsBodyHtml(): string {
        let oobBudget = FilterGroup.getRoomBudget(null);
        let objectsHtml = this.getObjectsHtml(null, 0);

        setTimeout(() => {
            this.controller.addEventListener('click', () => {
                FilterGroup.toggleRoomCollapsed(null);
                this.update();
            }, "room-name");
        }, 50);
        return `
        <tbody>
            <tr>
                <td>
                    <span id="room-name" style="float: left;font-weight: bold;">${FilterGroup.getRoomName(null)}</span>
                </td>
                <td>
                </td>
                <td>
                </td>
                <td>
                    <span style="float: left;font-weight: bold;">${oobBudget}€</span>
                </td>
            </tr>
            ${objectsHtml}
            <tr>
                <td>
                    <span style="float: left;font-weight: bold;">Total</span>
                </td>
                <td>
                </td>
                <td>
                </td>
                <td>
                    <span style="float: left;font-weight: bold;">${FilterGroup.getTotalBudget()}€</span>
                </td>
            </tr>
        </tbody>
        `;
    }

    destroy(): void {
        super.destroy();
        clearInterval(this.roomsWatcher);
        FilterGroup.removeEntitySelectionListener(this.updateTitles);
    }
}